import React, {Component} from 'react';
import './App.css';
import Tabs from './components/Tabs/Tabs';
import TabPanel from './components/Tabs/TabPanel';
import TabIcon from './components/Tabs/TabIcon';

class App extends Component {
    render() {
        return (
            <div className="App">
                <header className="App-header">
                </header>
                <div className="App-intro">
                    <Tabs isResponsive={true} responsiveWidth={500} defaultSelected={1}  showIconsVert={true} showIconsHorz={true}>
                        <TabPanel label={'Tab 1'} icon={<TabIcon />}>
                            Content for Tab 1
                        </TabPanel>
                        <TabPanel label={'Tab 2'} icon={<TabIcon />}>
                            Content for Tab 2
                        </TabPanel>
                        <TabPanel label={'Tab 3'} icon={<TabIcon />}>
                       {'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Doloribus quidem dolor voluptatum velit vel vitae in architecto pariatur. Nostrum distinctio, inventore sapiente, odit quasi facere pariatur optio sed, cum sit assumenda tempore quidem architecto provident error impedit. Veniam qui magni quasi aspernatur sint recusandae porro? Incidunt, eligendi modi. Ex adipisci cum enim aspernatur soluta iusto modi atque ipsa non perspiciatis ea, aut ab assumenda ullam maxime dolorem repellendus ratione nulla temporibus eius, quisquam, inventore fugit sint ipsam! Molestiae, magnam aliquam minima rerum necessitatibus voluptate corrupti unde exercitationem molestias, libero officiis ipsum corporis. Molestiae, magni ratione architecto eos, inventore tempora dolores explicabo, quis itaque voluptatibus sit quaerat excepturi! Sequi aut dolor rem blanditiis, dolorem provident minus consequuntur, ipsam corrupti deleniti ad alias totam delectus a fuga, adipisci nesciunt fugiat itaque animi omnis. Ad atque repellat, sed nobis quibusdam nulla aliquam natus iste, cum neque asperiores accusantium sunt, quis architecto perferendis! Eos corrupti temporibus voluptate neque dolorem odio omnis consequuntur. Incidunt quas optio, iure eum inventore, repellat magnam ipsam ea culpa labore accusantium, expedita natus enim temporibus voluptas fugit explicabo rem cupiditate quia architecto adipisci distinctio mollitia assumenda. Earum natus tenetur corrupti recusandae voluptas consequatur dignissimos tempore quia maiores fuga repellat quod error similique quis quos nisi neque, eius officiis sapiente? Dicta cumque corporis magni saepe, assumenda tempore fugit ullam sint eveniet natus excepturi inventore deserunt voluptatum delectus ad vitae ducimus ab, cupiditate quaerat maiores illum distinctio minus. Corrupti alias repellendus, sunt quibusdam iste dolor quas numquam amet praesentium porro iusto nulla!'}
                        </TabPanel>
                        <TabPanel label={'Tab 4'} icon={<TabIcon />}>
                            Content for Tab 4
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js